import axios from "axios";

class API {
    instance () {
        return axios.create({
            baseURL: formychat_admin_vars.rest_endpoint + '/',
            headers: {
                'X-WP-Nonce': formychat_admin_vars.rest_nonce || ''
            }
        });
    }
    
    get (url) {
        return this.instance().get(url);
    }

    post (url, data) {
        return this.instance().post(url, data);
    }

    put (url, data) {
        return this.instance().put(url, data);
    }

    delete (url, data) {
        return this.instance().delete(url, data);
    }
}

export default new API();